import React from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import DesktopSidebarMenus from './DesktopSidebarMenus';
import { createSidebarMenuComponents } from './sidebarMenuPrimitives';
import { SidebarFlyoutProvider, useSidebarFlyoutControl } from './SidebarFlyoutContext';

function DesktopSidebarMenuInner({
  collapsed,
  expandedMenus,
  activeMenuId,
  toggleMenu,
  setCollapsed,
  setExpandedMenus,
  ...menuProps
}) {
  const location = useLocation();
  const navigate = useNavigate();
  const { closeAllFlyouts } = useSidebarFlyoutControl();

  const {
    MenuItem,
    SubMenuItem,
    SubMenuGroup,
    ActionMenuItem,
    TopLevelActionItem,
    closeMobileSidebar,
  } = createSidebarMenuComponents({
    collapsed,
    expandedMenus,
    activeMenuId,
    toggleMenu,
    setCollapsed,
    setExpandedMenus,
    location,
    closeSidebarFlyouts: closeAllFlyouts,
  });

  return (
    <DesktopSidebarMenus
      collapsed={collapsed}
      MenuItem={MenuItem}
      SubMenuItem={SubMenuItem}
      SubMenuGroup={SubMenuGroup}
      ActionMenuItem={ActionMenuItem}
      TopLevelActionItem={TopLevelActionItem}
      closeMobileSidebar={closeMobileSidebar}
      pathname={location.pathname}
      // Leaving the tender workspace is a navigation, so the router hook stays
      // here and DesktopSidebarMenus remains free of them.
      onExitTenderWorkspace={() => navigate('/app')}
      {...menuProps}
    />
  );
}

/** Desktop sidebar tree wrapped with shared contextual flyout state. */
export default function DesktopSidebarMenuShell(props) {
  return (
    <SidebarFlyoutProvider>
      <DesktopSidebarMenuInner {...props} />
    </SidebarFlyoutProvider>
  );
}
